import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      undoSnackbarState: state => state.undo.state
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Undo.js